import './src/styles/style.scss'
import 'typeface-ubuntu'
import { isMeasurementEnabled, loadGtag, trackPageView } from './src/utils/analytics'

// Google Analytics est chargé pour tous, sauf si le visiteur a désactivé la mesure.
export const onClientEntry = () => {
  if (isMeasurementEnabled()) loadGtag()
}

export const onRouteUpdate = ({ location }) => {
  // Laisse React Helmet mettre à jour le titre avant l'envoi de la page vue.
  setTimeout(() => trackPageView(location.pathname + location.search + location.hash), 50)
}
